// extracted by mini-css-extract-plugin
export default {"menuBlock":"SH-z","title":"TH-z","nav":"UH-z","flexCell":"VH-z","facetLink":"WH-z"};